import CartRepository from '~repositories/CartRepository/CartRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import CartSidebar from '~domain/entities/CartSidebar/CartSidebar';
import { IRemovePayload } from '~api/CartAPI/ICartApiSdk';

export default class RemoveItemUseCase {
    private cartRepository: CartRepository;
    private cartSidebar: CartSidebar;
    private readonly skus: string[];
    private readonly collectionId?: number;
    private readonly cartId?: number;

    constructor({ skus, collectionId, cartId }: IRemovePayload) {
        this.cartRepository = diContainer.get(serviceNames.cartRepository);
        this.cartSidebar = diContainer.get(serviceNames.cartSidebar);
        this.skus = skus;
        this.cartId = cartId;
        this.collectionId = collectionId;
    }

    public execute = async () => {
        try {
            this.cartSidebar.setLoading(true);
            await this.cartRepository.removeItem({
                skus: this.skus,
                cartId: this.cartId,
                collectionId: this.collectionId
            });
            window.dispatchEvent(
                new CustomEvent('cart.removeFromCart', { detail: { product_sku: this.skus } })
            );
        } finally {
            this.cartSidebar.setLoading(false);
        }
    };
}
